import { z } from 'zod';
export const SearchSchema = z.object({
  pageIndex: z.number().default(0),
  pageSize: z.number().default(100),
  categories: z.array(z.string()).optional(),
  activityTypes: z.array(z.string()).optional(),
  memberId: z.string().optional(),
  startAt: z.string().optional(),
  endAt: z.string().optional()
});